<template>
    <div class="workflow-popover">
        This item is in the <strong>{{ workflowState }}</strong> state.

        <ul v-if="workflowSteps" class="workflow-popover__list">
            <li v-for="(wf, i) in workflowSteps" :key="i" class="workflow-popover__item">
                <button class="workflow-popover__cta-button" @click.prevent="onCommandClick(i)">
                    {{ wf.name }}
                </button>
            </li>
        </ul>
    </div>
</template>

<script>
import { mapState, mapActions } from 'vuex';

import { EXECUTE_WORKFLOW } from '@/store/types/action-types';

export default {
    name: 'workflow-popover',

    computed: {
        ...mapState({
            pageData: state => state.page.pageData,
            workflowSteps: state => state.page.workflowSteps,
        }),

        workflowState() {
            if (this.pageData) {
                return this.pageData.pageData.workflow.state;
            }

            return '';
        },
    },

    methods: {
        ...mapActions({
            executeWorkflow: EXECUTE_WORKFLOW,
        }),

        onCommandClick(index) {
            this.executeWorkflow({
                itemId: this.pageData.pageData.id,
                commandId: this.workflowSteps[index].id,
                comment: '',
            });
        },
    },
};
</script>

<style lang="scss">
    .workflow-popover {
        color: rgba(black, 0.75);
        background-color: white;
        padding: 5px 10px;
        font-size: 14px;

        &__list {
            margin: auto;
            padding-top: 15px;
        }

       &__cta-button {
            z-index: 2; // issue with z-index for toggles going over button
            padding: 7px 15px;
            margin: 4px 0;
            border-radius: 4px;
            font-size: 13px;
            color: var(--form-buttonColor);
            background-color: var(--form-buttonBackgroundColor);
            min-width: 100px;

            &:hover {
                color: var(--form-buttonHoverColor);
                background-color: var(--form-buttonHoverBackgroundColor);
            }
        }
    }
</style>
